/**
 * PanelHeaderButton — every button in a panel's header row: the ×, the
 * panel's corner actions, a back or menu button leading the row. A ghost
 * Occurra Button, 32px square unless it carries a label, its glyph in the
 * high-contrast foreground like the title beside it.
 *
 * Over a picture the caller adds a fill of its own; the box stays the same.
 */

import * as React from 'react';

import { Button } from '../Button';
import { cn } from '@/lib/utils';

type Props = Omit<React.ComponentProps<typeof Button>, 'variant' | 'size'>;

export const PanelHeaderButton = ({
    isIconOnly = true, className, ...props
}: Props): React.JSX.Element => (
    <Button
        variant="ghost"
        size="small"
        isIconOnly={isIconOnly}
        className={cn('occ-panel-header-button text-occ-foreground-high-contrast', className)}
        {...props}
    />
);
